import React from 'react';

import { ProductCarousel, ContentCard, Typography } from '@hpstellar/core/visId';

import './carousel-cards.less';

export default function CarouselCards({ cards }) {
    if (!cards || cards?.length < 1) {
        return null;
    }

    return (
        <div className="carouselCards">
            <ProductCarousel
                headerClassName="carouselCards-header"
                titleTypographyProps={{ className: 'carouselCards-title' }}
                EmblaCarouselProps={{ slideClassName: 'carouselCards-slide' }}
                title={
                    <Typography variant="h3" tag="h3">
                        Explore more about our products
                    </Typography>
                }
            >
                {cards?.map(card => {
                    const { gtmProps, ...cardProps } = card;
                    return (
                        <div className="carouselCards-container" {...gtmProps}>
                            <ContentCard
                                className="carouselCards-card"
                                {...cardProps}
                                imageProps={{ ...cardProps.imageProps, className: 'carouselCards-image' }}
                            />
                        </div>
                    );
                })}
            </ProductCarousel>
        </div>
    );
}
